export const processSteps = [
  {
    step: "01",
    icon: "ri-chat-3-line",
    title: "Besplatna konsultacija",
    description: "Naš stručnjak dolazi na vašu lokaciju, analizira objekat i potrebe, pa predlaže optimalno rešenje. Procena je potpuno besplatna i bez obaveza.",
  },
  {
    step: "02",
    icon: "ri-draft-line",
    title: "Projektovanje sistema",
    description: "Naši inženjeri kreiraju detaljan projekat sa pozicijama kamera, senzora i kontrolera. Dobijate 3D vizualizaciju pre same instalacije.",
  },
  {
    step: "03",
    icon: "ri-tools-line",
    title: "Profesionalna instalacija",
    description: "Sertifikovani tehničari instaliraju kompletan sistem u dogovorenom roku. Radimo čisto, precizno, sa minimalnim ometanjem vašeg prostora.",
  },
  {
    step: "04",
    icon: "ri-customer-service-2-line",
    title: "Obuka i podrška 24/7",
    description: "Obuka za korišćenje sistema, mobilna aplikacija, i 24/7 tehnička podrška. Redovno održavanje i monitoring po želji.",
  },
];

export const partnerBrands = [
  { name: "Hikvision", logo: "ri-eye-line" },
  { name: "Dahua", logo: "ri-camera-line" },
  { name: "Bosch", logo: "ri-shield-check-line" },
  { name: "Ajax Systems", logo: "ri-alarm-warning-line" },
  { name: "2N", logo: "ri-door-lock-line" },
  { name: "Milestone", logo: "ri-server-line" },
];

export const guaranteeContent = [
  {
    icon: "ri-shield-star-line",
    title: "3 godine garancije",
    desc: "Na svu opremu i instalaciju dajemo punu garanciju od 3 godine. Produžena garancija dostupna do 5 godina.",
  },
  {
    icon: "ri-24-hours-line",
    title: "24/7 Tehnička podrška",
    desc: "Naš tim je dostupan 24 časa dnevno, 365 dana u godini. Prosečno vreme odgovora je ispod 15 minuta.",
  },
  {
    icon: "ri-award-line",
    title: "Sertifikovana oprema",
    desc: "Sva oprema poseduje CE, FCC i RoHS sertifikate. Koristimo isključivo proverene svetske brendove.",
  },
  {
    icon: "ri-refresh-line",
    title: "Zamena u roku od 48h",
    desc: "U slučaju kvara, opremu menjamo u roku od 48 sati. Za kritične sisteme, zamena u roku od 4 sata.",
  },
];